export default __webpack_public_path__ + "card_ru.4b25dd19.png";